var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9182 21.7768C14.0243 21.7763 16.0697 21.0713 17.7287 19.7739L22.9448 24.99L24.6226 23.3122L19.4065 18.0961C20.7046 16.4369 21.4101 14.391 21.4106 12.2843C21.4106 7.05047 17.1521 2.79193 11.9182 2.79193C6.68432 2.79193 2.42578 7.05047 2.42578 12.2843C2.42578 17.5182 6.68432 21.7768 11.9182 21.7768ZM11.9182 5.16504C15.8445 5.16504 19.0375 8.35805 19.0375 12.2843C19.0375 16.2107 15.8445 19.4037 11.9182 19.4037C7.9919 19.4037 4.79889 16.2107 4.79889 12.2843C4.79889 8.35805 7.9919 5.16504 11.9182 5.16504Z",
    fill: "#3D64E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f7c35f4ae90f7dd818977363b125816c.svg";
export { ForwardRef as ReactComponent };